/* assets/ws-header.js (2026-10-07 PST). Loaded on every page by sections/header.liquid.
   LAST UPDATED: 2026-10-08 PST - part 3 added (the search panel in the header). Before that, the same day: part 1 ("Your Privacy Choices").
   1. "Your Privacy Choices" (the footer link with data-privacy-preferences): opens the privacy choices window of Shopify's cookie banner, the same call the
      live site makes (window.privacyBanner.showPreferences). When that window is not on the page (banner switched off, script blocked, local preview),
      the link is a normal link and opens its page, /pages/data-sharing-opt-out.
   2. Phone menu: the Menu button shows and hides the link list.
      Without JavaScript the links are still in the page (the list is only hidden by CSS on phones until opened).
   3. Search panel (owner feedback 2026-10-08 PST): the Search button opens a search field in the header (#ws-hsearch, markup in sections/header.liquid)
      instead of going to the search page. This file only opens and closes the panel and looks after the focus. The live suggestions are in
      assets/ws-search.js, which is added to the page the FIRST time the panel opens (never at page load).
      Close: Escape, the Close button, a click outside the header, or the focus leaving the header. The focus then returns to the Search button.
   VERSION HISTORY: 2026-10-07 PST first version. 2026-10-08 PST privacy choices. 2026-10-08 PST search panel. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-privacy-preferences]') : null;
    if (!t) return;
    var pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') { e.preventDefault(); pb.showPreferences(); }
  });

  var btn = document.getElementById('ws-mbtn');
  var nav = document.getElementById('ws-mnav');
  function set(open) {
    if (!btn || !nav) return;
    btn.setAttribute('aria-expanded', String(open));
    nav.setAttribute('data-open', String(open));
  }
  if (btn && nav) {
    btn.addEventListener('click', function () { var open = btn.getAttribute('aria-expanded') !== 'true'; if (open) closeSearch(false); set(open); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); }
    });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
  }

  /* ---------- 3. search panel ---------- */
  var header = document.getElementById('ws-header');
  var panel = document.getElementById('ws-hsearch');
  var sBtn = document.querySelector('[data-ws-search-open]');
  var input = document.getElementById('ws-hsearch-q');
  var scriptAsked = false;
  function searchOpen() { return !!panel && !panel.hidden; }
  function loadScript() {
    if (scriptAsked || !panel) return;   // asked one time only, also when the shopper clicks again before it has arrived
    scriptAsked = true;
    var src = panel.getAttribute('data-src'); if (!src) return;
    var s = document.createElement('script'); s.src = src; s.defer = true; document.head.appendChild(s);
  }
  function openSearch() {
    if (!panel || !sBtn || !input) return;
    set(false);
    panel.hidden = false; sBtn.setAttribute('aria-expanded', 'true');
    loadScript();
    input.focus(); input.select();
  }
  function closeSearch(refocus) {
    if (!searchOpen()) return;
    panel.hidden = true; sBtn.setAttribute('aria-expanded', 'false');
    if (refocus) sBtn.focus();
  }
  if (panel && sBtn && input) {
    sBtn.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;   // a new tab or window still opens the search page
      e.preventDefault();
      if (searchOpen()) closeSearch(true); else openSearch();
    });
    panel.addEventListener('click', function (e) { if (e.target.closest('[data-ws-search-close]')) closeSearch(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && searchOpen()) { e.preventDefault(); closeSearch(true); } });
    document.addEventListener('pointerdown', function (e) { if (searchOpen() && header && !header.contains(e.target)) closeSearch(false); });
    // the focus left the header (Tab past the last result): close, so the open panel does not cover the page for a keyboard user
    header.addEventListener('focusout', function (e) { if (searchOpen() && e.relatedTarget && !header.contains(e.relatedTarget)) closeSearch(false); });
  }
})();
